import React from "react";
import { withStyles } from "material-ui/styles";

import { Button } from "material-ui";
import PreviewModalContainer from "containers/CreateSurvey/PreviewModalContainer";
import { charcount } from "utils/formatter";

import CInput from "uis/CInput";

const styles = () => ({
  paperTitle: {
    color: "#575962",
    display: "inline-block",
    fontSize: "1.1rem",
    fontWeight: 600,
    marginLeft: 10
  },
  paperRow: {
    marginBottom: 15
  },
  paperDesc: {
    color: "#9699a2",
    fontSize: "1rem",
    fontWeight: 300,
    marginBottom: 5
  },
  paperValue: {
    color: "#575962",
    marginTop: "0.1rem",
    marginLeft: "2rem",
    display: "inline-block",
    fontSize: "1.1rem",
    fontWeight: 600
  }
});

const QuestionSettingPanel = props => {
  const { classes, items, selectedItemId, localeNo } = props;
  if (!items[localeNo]) {
    return null;
  }

  const item =
    items[localeNo] &&
    items[localeNo].filter(c => c.id - selectedItemId === 0)[0];
  const itemIndex = items[localeNo] ? items[localeNo].indexOf(item) : 0;
  return (
    <div
      style={{
        position: "relative",
        height: "100%"
      }}
    >
      <div style={{ backgroundColor: "#f4f5f8", padding: "5px 10px" }}>
        <div className={classes.paperTitle}>設問</div>
      </div>
      <div style={{ padding: 10 }}>
        <div>
          <span className={classes.paperDesc}>タイトル</span>
          <span className={classes.paperValue}>
            {item && `Q${item.id} ${item.title}`}
          </span>
        </div>
        <div>
          <div className={classes.paperDesc}>設問文*</div>
        </div>
        <div
          className={classes.paperPeriod}
          style={{ marginLeft: 0, width: "100%" }}
        >
          <CInput
            value={item && item.content}
            multiline
            fullWidth
            rows="8"
            disabled={!props.isEdit}
            onChange={e => {
              if (charcount(e.target.value) > 165) return;
              props.changeItem("content", e.target.value);
            }}
          />
        </div>
      </div>
      <div>
        <Button
          disabled={!props.isEdit || itemIndex === 0}
          size="medium"
          className={classes.button}
          onClick={props.handlePrev}
        >
          前へ
        </Button>
        <Button
          disabled={!props.isEdit || items[localeNo].length - 1 === itemIndex}
          size="medium"
          className={classes.button}
          style={{ float: "right" }}
          onClick={props.handleNext}
        >
          次へ
        </Button>
      </div>
      <div
        style={{
          position: "absolute",
          right: 0,
          bottom: 0,
          margin: 10
        }}
      >
        <Button
          disabled={!props.isEdit}
          dense
          raised
          onClick={() =>
            props.openPreviewModal(localeNo, selectedItemId, items, false)
          }
        >
          基本設問プレビュー
        </Button>
        <PreviewModalContainer />
      </div>
    </div>
  );
};
export default withStyles(styles)(QuestionSettingPanel);



// WEBPACK FOOTER //
// ./src/components/CreateSurvey/BaseWord/QuestionSettingPanel.jsx